<template>
<div id="ready-to-reconcile">
  <v-container fluid>
    <v-radio-group
      v-model="radioRow"
      row
    >
      <v-radio
        label="943"
        value="radio-1"
      ></v-radio>
      <v-radio
        label="944"
        value="radio-2"
      ></v-radio>
    </v-radio-group>
  </v-container>
  <v-container id="Rtable">
    <v-data-table
    v-model="selected"
    :headers="headers"
    :items="documents"
    item-key="client_id"
    disable-pagination
    hide-default-footer
    class="elevation-1"
    mobile-breakpoint="0"
  >
      <template v-slot:item.legal_name="{ item }">
        <div style="cursor: pointer" @click="goToClient(item.client_id)">
          {{item.legal_name}}
        </div>
      </template>

      <template v-slot:item.trade_name="{ item }">
        <div style="cursor: pointer" @click="goToClient(item.client_id)">
          {{item.trade_name}}
        </div>
      </template>
      <template v-slot:item.original_file_name="{ item}">
       <a
           :download="item.original_file_name"
           :href="item.url"
           target="_blank"
           class="ml-2"
           type="button"
           title="Download file">{{item.original_file_name}}</a>
      </template>
  <template v-slot:item.status_name="{ item}">
      <v-chip
        :color="getColor(item.status_name)"
      >
        {{ item.status_name }}
      </v-chip>
    </template>
      <template v-slot:item.actions="{ item }">
       <v-btn @click="claimJob(item)" class="mr-3"  color="success">Claim</v-btn>
       <v-btn @click="acceptFile(item)" class="mr-3"  color="success">Accept</v-btn>
       <v-btn @click="openRejectDialog(item)" color="red">Reject</v-btn>
      </template>
  </v-data-table>
    <div v-if="documents.length" class="d-flex justify-space-between mx-12 mt-6">
      <h3 v-if="documents.length" class="mt-4 ml-2">Total client count: {{documents.length}}</h3>
     <div >
       <h4>Blocked: {{blocked}}</h4>
       <h4>Checked out: {{claimed}}</h4>
       <h4>Available: {{ documents.length - claimed }}</h4>
     </div>
    </div>
  </v-container>
  <v-overlay :value="loading">
    <v-progress-circular
        :size="70"
        :width="7"
        color="white"
        indeterminate
    ></v-progress-circular>
  </v-overlay>

  <v-dialog width="800" v-model="rejDialog">
    <div class="pa-10">
      <v-card>
        <div class="pa-2">
          <h4>Please describe why you reject that file</h4>
          <div class="mb-5 d-flex flex-row align-center">
            <v-text-field
                v-model="rejectReason"

            ></v-text-field>

            <v-btn  @click="rejectFile" class="ml-5" style="height: 40px; width: 15%;" color="#263B4F">
              <span style="color: #FFFFFF">reject</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </div>
  </v-dialog>

  <v-dialog width="800" v-model="dialog">
  <div class="pa-10">
    <v-card>
      <div class="pa-2">
        <h4>Upload Completed Files for {{selectedClient.trade_name}}</h4>
        <div class="mb-5 d-flex flex-row align-center">
          <v-file-input
              v-model="uploadedFile"
              counter
              show-size
              accept=".csv, .xlsx"
              truncate-length="15"
              label="File input"
              class="mr-5"
              ref="sanitizedFile"
          ></v-file-input>

          <v-btn  @click="uploadBtn"  style="height: 40px; width: 15%;" color="#263B4F">
            <span style="color: #FFFFFF">Upload</span>
          </v-btn>
        </div>
      </div>
    </v-card>
  </div>
  </v-dialog>
  <ProfileClientDialog
      v-if="showRightDialogChosenClient"
      :key="dialogKeyChosenClient"
      :showRightDialogChosenClient.sync="showRightDialogChosenClient"
      :clientProp="clientProp"
      @openClientProfileDialog="openClientProfileDialog"

  />
</div>
</template>
<script>
import ClientsService from "@/services/clients.service";
import ClientService from "@/services/clients.service";
import ProfileClientDialog from "@/components/Client/ProfileClientDialog.vue";
import SanitizerService from "@/services/sanitizer.service";
import {mapGetters} from "vuex";
export default {
  components: {ProfileClientDialog},
    data () {
      return {
        dialog:false,
        uploadedFile:'',
        selected: [],
        headers: [
          {text: 'Legal name',align: 'start',sortable: false, value: 'legal_name'},
          {text: 'Trade name',align: 'start',sortable: false, value: 'trade_name'},
          { text: 'Uploaded File', value: 'original_file_name' },
          { text: 'Days in queue', value: 'days_in_queue' },
          { text: 'Status', value: 'status_name' },
          { text: '', value: 'actions' },
        ],
        documents: [],
        showRightDialogChosenClient:false,
        dialogKeyChosenClient:33,
        clientId:'',
        clientProp:{},
        loading:false,
        selectedClient:{},
        statuses:[],
        rejectReason:'',
        rejDialog:false,
        claimed:0,
        blocked:0,
        selectedClientName:'',
        radioRow:'' 
      }
    },
  computed: {
    ...mapGetters(
        {
          currentUser: 'auth/getCurrentUser',
          // clientID: 'sanitization/getClientID',
          // daysInQueue: 'sanitization/getDaysInQueue',
          // sanitizeJobID: 'sanitization/getSanitizeJobID',
          // tradingName: 'sanitization/getTradingName'
        },
    ),
  },
  watch:{
      radioRow(newChoice, oldChoice){
        const payload= {
        business_type:'941'
      }
      if (newChoice=='radio-1'){
        payload.business_type='943'
      } else if (newChoice=='radio-2') {
        payload.business_type='944'
      }
        this.getReconciled(payload)
      }
    },
    methods: {
      claimJob(item){
        this.loading=true
        const model = {
          "status": 4
        }
        ClientsService.patchReconciliation(item.queue_id,model)
            .then(()=>{
              this.getReconciled()
            })
      },
      goToClient(id){
        this.loading = true
        return ClientService.getOneClient(id)
            .then((data) => {
              this.clientProp = data;
              this.openClientProfileDialog();
              this.clientId = Number(this.clientProp.id);
              // this.showResults = false;
              // this.inputSearch = null;
            })
            .catch((error) => {
              this.loading = false
              this.$store.dispatch('snackbar/showSnackbarMessage', {
                message: `${error.response.data.error}. Please, try again.`,
                duration: 4000,
                mode: 'fail'
              });
            });
      },
      openClientProfileDialog() {
        this.showRightDialogChosenClient = true;
        this.dialogKeyChosenClient++;
        this.loading = false
        this.showRightDialog = false;
      },
      openRejectDialog(item){
        this.rejDialog = true
        this.selectedClient=item
      },
      uploadBtn() {
        this.loading=true
        const formData = new FormData();
        const csvFile = [this.uploadedFile];
        formData.append("uploaded_file", csvFile[0]);
        formData.append('upload_type', 'payroll');
        ClientService.uploadClientCSVFile(this.selectedClient.client_id, formData)
            .then(() => {
              this.$store.dispatch('snackbar/showSnackbarMessage', {
                message: 'File uploaded successfully',
                duration: 4000,
                mode: 'success'
              });
              this.patchClient(2)
              this.goToClient(this.selectedClient.client_id)
            }).catch(()=>this.processingFile = false)
      },
      patchClient(stat){
        const model = {
          'status':stat,
          'reason':this.rejectReason
        }
        ClientsService.patchReconciliation(this.selectedClient.queue_id,model)
            .then(res=>{
              this.getReconciled()
              this.uploadedFile = ''
              this.rejDialog=false
              this.dialog=false
              this.loading=false
            })
      },
      acceptFile(item) {
        this.dialog = true
        this.selectedClient = item
      },
      rejectFile(item) {
        this.patchClient(3)
      },
      getColor (status) {
        if (status== 'Rejected') return 'red'
        else if (status== 'Reconciled') return 'black'
        else return 'green'
      },

      getReconciled(payload){
        ClientsService.getReadyToReconcileDocs(payload)
          .then((res)=>{
            this.claimed=0
            this.blocked=0
            this.documents = res
            this.documents.forEach(e=>{
              if (e.status_id == 3){
                this.blocked++
              }else if(e.status_id == 4){
                this.claimed++
              }
            })
            this.loading=false
          }).catch((err) => {console.log('err:',err)})
      },
      getStatuses() {
        ClientsService.getReconciliationQueueStatuses()
          .then(res => {
            this.statuses = res
          }).catch((err) => {console.log('err:',err)})
      },
      reconcile(id,status){
        ClientsService.patchReadyToReconcile(id, status)
          .then((res)=>{}).catch((err) => {console.log('err:',err)})
      },
      patch(status){
        if(!this.selected.length) return
        status=Number(status)
        const data = {
          "status":status
        };
        this.selected.forEach((element,i) => {
          this.reconcile(element.queue_id, data)
        });
        this.getReconciled()
      }

    },
    mounted(){
      this.getReconciled()
      this.getStatuses()
    }
};
</script>
<style scoped>
#ready-to-reconcile .v-btn{
    color:#fff;
    background: #263B4F;
    
}
#ready-to-reconcile .btnHolder{
    text-align: center;
}
#Rtable .v-data-table{
    margin: 0 auto;
}

#ready-to-reconcile .text-start span{
  color: white;
}
</style>
